import React, { useEffect } from 'react';
import { useGooglePay } from '../../business/processors/recurly/GooglePayService';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { getString } from '../../constants/Strings';
import { GooglePayButton } from './styled';
import { sendRioEvent, SpecType, SubType } from '@chegg/commerce-utils';
import { sendRioEventCallback } from '../../utils/CallbackUtils';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
export var RecurlyGooglePay = function RecurlyGooglePay() {
  var config = useAppSelector(configSelector);
  var rioNamespace = config.rioNamespace;
  var googePayButtonContainerId = useGooglePay();
  useEffect(function () {
    // RIO Logging: GooglePay button display successfully
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.GOOGLEPAY_LOADED'),
      specType: SpecType.COMPONENT_VIEW,
      subType: SubType.COMPONENT,
      callback: sendRioEventCallback,
      namespace: rioNamespace,
      force: false
    });
  }, []);
  return /*#__PURE__*/React.createElement(GooglePayButton, {
    id: googePayButtonContainerId,
    "aria-label": getString('APP.GOOGLEPAY.START_BUTTON.ARIA_LABEL'),
    "data-test": DataTestAttributes.RECURLY_GOOGLEPAY_BUTTON
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/GooglePay/RecurlyGooglePay.js
// module id = 4631
// module chunks = 11